module.exports = __webpack_public_path__ + "od-gift-icon/od-gift-icon-699e5611fc71a414459af21977ccd0b5.svg";